// Shared className tokens for ChatMap node renderers.
//
// Each token is a Tailwind utility string the renderers concatenate
// into their `className` props. The point isn't DRY for its own sake
// — it's that the node family looks/feels like ONE system instead of
// 8 components that drifted independently. A future palette tweak
// touches one file, not 8.

// Tiny ALL-CAPS pip header used at the top of every content-bearing
// node ("⚡ Synthesis", "🤖 Assistant", "👤 You", "▸ N peers", etc).
// Pair with a per-role color via the caller's classname tail.
export const PIP_HEADER_CLASS =
  'text-[9px] uppercase tracking-widest font-bold';

// Compact mono meta line for token / cost / duration chips. Used in
// the asst marker, the synth round, the peer card, the fan-collapsed
// chip, etc. Caller provides the per-context opacity / color tail.
export const META_LINE_CLASS = 'text-[10px] font-mono';

// Italic in-card lead-in for INPUT-side previews ("asks:", "args:").
// Emerald per the input/output color split (peer asks: + tool args:).
// Caller provides dark/light mode tail (text-emerald-300/80 vs 700/80).
export const INPUT_LEAD_CLASS = 'text-[10px] italic';

// Italic in-card lead-in for OUTPUT-side previews ("says:" on peers,
// "↓ answer" on synth). Cyan per the input/output color split.
export const OUTPUT_LEAD_CLASS = 'text-[10px] italic leading-tight';

// Hover-lift transition shared by every CLICKABLE node card so the
// whole map "responds" the same way to mouse hover. Card-deck nodes
// (FanCollapsedChip, CollapsedPhaseStackNode) bake this into their
// own className; clickable spine nodes opt in via this token.
export const HOVER_LIFT_CLASS =
  'transition-transform hover:-translate-y-0.5 hover:shadow-md';

// Uniform selection ring applied when ReactFlow's `selected` prop is
// true. Shared so click + future keyboard nav land the same visual.
export const SELECTION_RING_CLASS = 'ring-2 ring-emerald-500/70';
